module.exports = __webpack_public_path__ + "img/index-multifocalsunglasses.4a74b7f9.svg";